import { createActionsHook, createContainer, createHook, createStore } from 'react-sweet-state';

import { fg } from '@atlaskit/platform-feature-flags';

import { actions, type Actions } from './actions';
import type { Props, State } from './common/types';
import {
	getExtendedContentColumnLayout,
	getExtendedContentWidth,
	getHasExtendedContent,
} from './selectors';
import { getExtendedContentLayout, getTotalExtendedContentWidth } from './utils';

const initialState: State = {
	columnLayout: [],
	extendedContentWidth: 0,
	hasExtendedContent: false,
};

export const extendedContentStore = createStore<State, Actions>({
	initialState,
	actions,
	name: 'timeline-table.extended-content',
});

export const useExtendedContentActions = createActionsHook(extendedContentStore);

export const useExtendedContentWidth = createHook(extendedContentStore, {
	selector: getExtendedContentWidth,
});

export const useExtendedContentLayout = createHook(extendedContentStore, {
	selector: getExtendedContentColumnLayout,
});

export const useHasExtendedContent = createHook(extendedContentStore, {
	selector: getHasExtendedContent,
});

export const useExtendedContentState = createHook(extendedContentStore);

export const ExtendedContentProvider = createContainer<State, Actions, Props>(
	extendedContentStore,
	{
		onInit:
			() =>
			({ setState }, { extendedContent }: Props) => {
				setState({
					extendedContentWidth: getTotalExtendedContentWidth(extendedContent ?? []),
					columnLayout: getExtendedContentLayout(extendedContent ?? []),
					hasExtendedContent:
						Boolean(extendedContent && extendedContent.length > 0) &&
						fg('timeline_table_extended_content'),
				});
			},
		onUpdate:
			() =>
			({ setState }, props) => {
				setState({
					extendedContentWidth: getTotalExtendedContentWidth(props.extendedContent ?? []),
					columnLayout: getExtendedContentLayout(props.extendedContent ?? []),
					hasExtendedContent:
						Boolean(props.extendedContent && props.extendedContent.length > 0) &&
						fg('timeline_table_extended_content'),
				});
			},
	},
);

export default ExtendedContentProvider;
